import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, r = /* @__PURE__ */ e("g", { "clip-path": "url(#user-add_svg__a)" }, [
  /* @__PURE__ */ e("path", {
    fill: "currentColor",
    d: "M32 4.25v2.5h-4.25V11h-2.5V6.75H21v-2.5h4.25V0h2.5v4.25zm-.194 9.25q.193 1.231.194 2.5c0 4.274-1.664 8.292-4.686 11.314A15.9 15.9 0 0 1 16 32a15.9 15.9 0 0 1-11.314-4.686A15.9 15.9 0 0 1 0 16c0-4.274 1.664-8.292 4.686-11.314A15.9 15.9 0 0 1 16 0q1.269.001 2.5.194v2.539A13.5 13.5 0 0 0 16 2.5C8.556 2.5 2.5 8.556 2.5 16c0 3.407 1.27 6.524 3.36 8.902a10.43 10.43 0 0 1 5.96-7.23 6.2 6.2 0 0 1-2.03-4.588A6.216 6.216 0 0 1 16 6.876a6.217 6.217 0 0 1 6.21 6.21 6.2 6.2 0 0 1-2.03 4.587 10.43 10.43 0 0 1 5.96 7.23A13.44 13.44 0 0 0 29.5 16c0-.854-.08-1.69-.233-2.5zM16 16.794a3.714 3.714 0 0 0 3.71-3.71A3.713 3.713 0 0 0 16 9.375a3.714 3.714 0 0 0-3.71 3.71A3.714 3.714 0 0 0 16 16.794M16 29.5c2.943 0 5.669-.948 7.89-2.552-.128-4.242-3.617-7.654-7.89-7.654s-7.762 3.412-7.89 7.654A13.43 13.43 0 0 0 16 29.5"
  })
], -1), s = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "user-add_svg__a" }, [
    /* @__PURE__ */ e("path", {
      fill: "currentColor",
      d: "M0 0h32v32H0z"
    })
  ])
], -1), l = [
  r,
  s
];
function n(a, d) {
  return t(), o("svg", c, [...l]);
}
const h = { render: n };
export {
  h as default,
  n as render
};
